import {
  CLEAR_VPP_KEY,
  GET_VPP_KEY_SITE_FAILURE,
  GET_VPP_KEY_SITE_REQUEST,
  GET_VPP_KEY_SITE_SUCCESS,
} from "actions/vpp";

const initialState = {
  loading: false,
  error: {},
  vppKey: {
    site: "",
    user: "",
    source: "",
    vpp_platform: "",
    key: "",
    active: 0,
  },
};

export default function vpp(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_VPP_KEY_SITE_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_VPP_KEY_SITE_SUCCESS: {
      return {
        ...state,
        loading: false,
        vppKey: payload,
      };
    }

    case GET_VPP_KEY_SITE_FAILURE: {
      return {
        ...state,
        loading: false,
        vppKey: {},
      };
    }

    case CLEAR_VPP_KEY: {
      return {
        ...initialState,
      };
    }

    default:
      return state;
  }
}
